module.exports = __webpack_public_path__ + "static/media/previewbannerb.4bc39c4d.svg";